
export enum ExpenseEnum {
    MATERIAL = "materialExpense",
    CORPORATE = "corporateTax",
    ELECTRICITY = "electricityExpense",
    MAINTENANCE = "maintenanceExpense",
    MISCELLANEOUS = "miscellaneousExpense",
    RENT = "rent"
}